import { VStack } from '@betterment/samba-react';

import { ExternallyAdvisedPortfolioAllocationRow, PortfolioAllocationRow } from './components/PortfolioAllocationRow';
import { PortfolioStandaloneDisclosure } from './components/PortfolioDisclosures';
import { PortfolioMessages } from './components/PortfolioMessages';
import { PortfolioStrategyRow } from './components/PortfolioStrategyRow';
import { PortfolioStrategyStats } from './components/PortfolioStrategyStats';
import { SelfDirectedPortfolio } from './data';

import { MessageFragment } from '../../../../graphql/fragments/message.generated';

type Props = {
  portfolio: SelfDirectedPortfolio;
  legacyGoalId: number;
  hasEverBeenFunded: boolean;
  messages: MessageFragment[];
};

export const SelfDirectedPortfolioStrategy: React.FC<React.PropsWithChildren<Props>> = props => {
  const { portfolio, legacyGoalId, hasEverBeenFunded, messages } = props;
  const {
    isExternallyAdvised,
    name,
    disclosureUrl,
    hasPendingPortfolioChangeRequest,
    targetAllocationDescription: allocationDescription,
    isAllocationEditable,
    isStrategySelectionEligible,
  } = portfolio;

  return (
    <VStack css={{ gap: 'space.300' }}>
      <VStack css={{ gap: 'space.150' }}>
        {isExternallyAdvised ? (
          <ExternallyAdvisedPortfolioAllocationRow
            legacyGoalId={legacyGoalId}
            allocationDescription={allocationDescription}
          />
        ) : (
          <>
            <PortfolioStrategyRow
              legacyGoalId={legacyGoalId}
              name={name}
              isEditable={isStrategySelectionEligible}
              hasPendingPortfolioChangeRequest={hasPendingPortfolioChangeRequest}
            />
            {isAllocationEditable && (
              <PortfolioAllocationRow legacyGoalId={legacyGoalId} allocationDescription={allocationDescription} />
            )}
          </>
        )}
      </VStack>
      <PortfolioMessages messages={messages} />
      <PortfolioStrategyStats portfolio={portfolio} hasEverBeenFunded={hasEverBeenFunded} />
      {disclosureUrl && <PortfolioStandaloneDisclosure disclosureUrl={disclosureUrl} />}
    </VStack>
  );
};
